import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { PriceFacade } from '../facades/price.facade';

export function priceCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        inject(PriceFacade).clear();
        return true;
    };
}
